import { useEffect, useState } from "react";
import {
  Alert,
  Fade,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
} from "@mui/material";
import * as React from "react";
import { getSubcategories, postSubcategories, useApi } from "../api/Api";

const SubCategoryPreferences = ({ langChanged }) => {
  const api = useApi();

  const [subcategories, setSubcategories] = useState([]);
  const [fetched, setFetched] = useState(0);
  const [updateError, setUpdateError] = useState("");

  const fetchSubcategories = () => {
    getSubcategories(api)
      .then((response) => {
        setSubcategories(response["data"]["subcategories"]);
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  useEffect(() => {
    fetchSubcategories();
  }, []);

  useEffect(() => {
    fetchSubcategories();
  }, [langChanged]);

  useEffect(() => {
    setUpdateError("");
    if (fetched > 1) {
      postSubcategories(api, { subcategories })
        .then((response) => {
          console.log("response", response.data);
        })
        .catch((error) => {
          console.log("error", error.response);
          setUpdateError(error.response["data"]);
        });
    } else {
      setFetched(fetched + 1);
    }
  }, [subcategories]);

  const updateSubcategories = (event, key) => {
    let cpy = [...subcategories];
    cpy[cpy.findIndex((subcatg) => subcatg.key === key)].checked =
      event.target.checked;
    setSubcategories(cpy);
  };

  const switches = subcategories.map(({ key, name, checked }) => (
    <FormControlLabel
      key={key}
      control={
        <Switch
          key={key}
          checked={checked}
          onChange={(event) => updateSubcategories(event, key)}
        />
      }
      label={name}
    />
  ));

  return (
    <Paper elevation={3} sx={{ px: 2, py: 1 }}>
      {switches}
      {updateError === "" ? (
        <></>
      ) : (
        <Fade in={true}>
          <Grid item xs={12}>
            <Alert severity="error">{updateError}</Alert>
          </Grid>
        </Fade>
      )}
    </Paper>
  );
};

export default SubCategoryPreferences;
